export default "__VITE_ASSET__da0a7eaf__"